import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_QUOTATION_ENTITY, QuotationEntity } from "domain/entity/QuotationSetting/QuotationEntity";
import { QuotationRepository } from "domain/repository/QuotationSetting/QuotationRepo";
import _ from "lodash";
import { createQuotationSettingValidationSchema } from "presentation/constant/QuotationSetting/QuotationSettingValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { QuotationModel } from "presentation/model/QuotationSetting/QuotationModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface QuotationVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<QuotationModel>> | ((value: SetStateAction<QuotationModel>) => void),
    ],
    repo: QuotationRepository,
}

export const QuotationVM = ({ dispatch, repo }: QuotationVMProps) => {
    const [quotationDispatch] = dispatch;

    const onSearch = async () => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                auditLogList: []
            }
        });
        await repo.getEntities().then((data) => {
            quotationDispatch(prevState => {
                return {
                    ...prevState,
                    quotationList: data,
                    isShowEditPanel: false,
                    isAdd: false,
                    isEdit: false,
                }
            });
        });
    }

    const onCloseEidtPanel = async () => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_QUOTATION_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        });
    }

    const onSave = async (row: QuotationEntity) => {
        const valResult = await Validation(createQuotationSettingValidationSchema).ValidateFormOnly(row);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            quotationDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await repo.onSave(row);
    }

    const onSaveClicked = () => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_QUOTATION_ENTITY } : prevState.currentRow,
            }
        })
    }

    const onEditClick = async () => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
            }
        })
    }

    const onRowDoubleClick = async (entity: QuotationEntity) => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onAddClick = async () => {
        quotationDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_QUOTATION_ENTITY },
                isAdd: true,
                isShowEditPanel: true,
            }
        })
    }

    const updateSelectedRows = async (rows: QuotationEntity[]) => {

        quotationDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
            }
        })
    }
    const onCoVslVoyChange = (inputData: { co?: string, vsl?: string, voy?: string }, fieldName: { co: string, vsl: string, voy: string }) => {
        let coVal: string = "";
        let vslVal: string = "";
        let voyVal: string = "";
        if (inputData?.co) {
            coVal = inputData?.co.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.vsl) {
            vslVal = inputData?.vsl.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.voy) {
            voyVal = inputData?.voy.toUpperCase();
        }
        quotationDispatch(prevState => ({
            ...prevState,
            currentEditRow: {
                ...prevState.currentEditRow,
                [fieldName.co]: coVal,
                [fieldName.vsl]: vslVal,
                [fieldName.voy]: voyVal,
            },
            masterState: {
                ...prevState.masterState,
                allFormState: {
                    ...prevState.masterState.allFormState,
                    consortiumCode: _.isEmpty(coVal) ? prevState.masterState.allFormState?.consortiumCode ?? '' : '',
                    vesselCode: _.isEmpty(vslVal) ? prevState.masterState.allFormState?.vesselCode ?? '' : '',
                    voyageCode: _.isEmpty(voyVal) ? prevState.masterState.allFormState?.voyageCode ?? '' : ''
                },
            }

        }))
    }

    return {
        onCoVslVoyChange: onCoVslVoyChange,
        onSave: onSave,
        onSearch: onSearch,
        updateSelectedRows: updateSelectedRows,
        onAddClick: onAddClick,
        onRowDoubleClick: onRowDoubleClick,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onCloseEidtPanel: onCloseEidtPanel,
        onSaveClicked: onSaveClicked,

    }
}